const REASONS = [
  'Driver: Medical Issue',
  'Driver: Lost or Needs Directions',
  'Driver: No Straight Answer',
  'Driver: Unresponsive',
  'Driver: Incorrect ETA (Booking)',
  'Truck: Mechanical Issues',
  'Situational: Weather',
  'Situational: Road Closures',
  'Situational: Traffic',
  'Situational: FCFS Nearing Appt End',
  'Planning: Hours',
  'Planning: Wrong Address',
  'Planning: Covered After Appt',
  'Facility: Loading Delay',
  'Facility: Not empty at previous del',
  'Workflow: No In/Out Times',
  'Other',
]

export const LATE_REASONS = REASONS.map(reason => ({ label: reason, value: reason }))
